import { useContext } from 'react'

import { CommonGAssets } from '@hhgtech/hhg-components/gAssets'
import { Text } from '@hhgtech/hhg-components/mantine'
import { Box, BoxProps } from '@mantine/core'

import useStyles from './index.styles'
import SectionWrapper from '../../sectionWrapper'
import { ScheduleEventContext, ScheduleEventStatus } from '../context'

type GameRulesProps = {
  state?: ScheduleEventStatus
} & BoxProps

export const GameRules = ({
  className,
  classNames,
  styles,
  ...rest
}: GameRulesProps) => {
  const { wrapperProps } = useContext(ScheduleEventContext)
  const { classes } = useStyles(undefined, {
    name: 'ScheduleEvent__GameRules',
    styles,
    classNames,
  })
  return (
    <SectionWrapper.Wrapper
      className={className}
      classNames={{ root: classes.root }}
      {...wrapperProps}
    >
      <Box className={classes.wrapper} {...rest}>
        <Box className={classes.border} />
        <Box className={classes.bannerWrapper}>
          <img
            src={CommonGAssets.getAssetPath('tiki/game-rules.png')}
            loading="lazy"
            className={classes.banner}
            alt="THỂ LỆ MINI GAME"
          />
        </Box>
        <Box className={classes.header}>
          <h3 className={classes.heading}>THỂ LỆ MINIGAME</h3>
        </Box>
        <Box className={classes.listing}>
          <Text size="p3" className={classes.item} as="div">
            <div
              dangerouslySetInnerHTML={{
                __html: `<p>200 bạn may mắn đăng ký đầu tiên sẽ được nhận mã Coupon thông qua tin nhắn của HelloBACSI.</p><p>Ngoài ra, HelloBACSI sẽ gửi tin nhắn SMS nhắc nhở kèm đường dẫn xem livestream 15 phút trước khi chương trình bắt đầu cho các bạn đăng ký thành công.</p>`,
              }}
            />
          </Text>
          <Text size="p3" className={classes.item} as="div">
            <div
              dangerouslySetInnerHTML={{
                __html: `<p>Trị giá coupon: Giảm 50% tối đa 100K áp dụng cho toàn bộ sản phẩm tại Tiki.vn. Mỗi bạn có 1 mã riêng, 1 số điện thoại chỉ nhận được 1 mã duy nhất.</p>
<p>Thời hạn sử dụng coupon: 01.11.2024 - 14.11.2024.</p>`,
              }}
            />
          </Text>
        </Box>
        <Box className={classes.border} />
      </Box>
    </SectionWrapper.Wrapper>
  )
}
